module.exports = __webpack_public_path__ + "img/sample-blue.0cd07622.svg";